<template>
    <div class="alert alert-secondary" :class="optional_class" role="alert">
        {{ text }}
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'AlertNoRecord',
    props: {
        text: {
            type: String,
            default: 'データがありません'
        },
        optional_class: {
            type: String,
            default: ''
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .alert { padding: 0.5rem 0.5rem; margin-bottom: 0; }
</style>
